/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     PortalRedirect
//   Details:    PortalRedirect store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 106380 30/04/20 JC       New
// 103839 13/05/20 JC  M01  Added TeamPortal redirect
//-------------------------------------------------------
*/
import { fetchActions } from "../FetchWrapper";
import { history } from '../history';

export const toPortalRequestType = 'PORTALREDIRECT_TOPORTAL_REQUEST';
export const toPortalSuccessType = 'PORTALREDIRECT_TOPORTAL_SUCCESS';
export const toPortalFailureType = 'PORTALREDIRECT_TOPORTAL_FAILURE';
export const cleanUpType = 'PORTALREDIRECT_CLEANUP';

const initialState = {
    isLoading: false,
    ssoAuthenticationTicket: ""
};

export const portalRedirectActions = {
    toPortal,
    cleanUp
};

function toPortal(portalRedirectType, portalLoginURL) { //M01
    return (dispatch, getState) => {
        dispatch(_toPortalRequest());
        
        const url = getState().clientConfiguration.config.endpoint + "/Redirect/ToPortal";
        const ticket = getState().authentication.user.ticket;
        const query = `?PortalRedirectType=${portalRedirectType}`;

        fetchActions.post(url + query, ticket)
            .then(
                response => {
                    let data = response.data;
                    // login successful if there's a token in the response
                    if (data.ticket) {

                        //dispath success
                        dispatch(_toPortalSuccess(data.ticket));

                        //get the link
                        let link = "";
                        if (portalLoginURL && data.ticket && data.ticket != "") { //M01
                            link = `${portalLoginURL}login/ssoAuthenticationTicket/${data.ticket}`; //M01
                        }

                        //open the url in a new tab
                        window.open(link, "_blank");      

                        //push back to main page
                        history.push("/")

                    } else {
                        var message = "Could not log in";
                        dispatch(_toPortalFailure(message));
                    }                    
                },
                error => {
                    var message = `Could not log in: ${error.message}`;
                    dispatch(_toPortalFailure(message));
                }
            );
    };
}

function cleanUp() {
    return (dispatch) => {
        dispatch(_cleanUp());
    };
}

function _toPortalRequest() { return { type: toPortalRequestType }; }
function _toPortalSuccess(ticket) { return { type: toPortalSuccessType, ticket }; }
function _toPortalFailure(error) { return { type: toPortalFailureType, error }; }
function _cleanUp() { return { type: cleanUpType }; }

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === toPortalRequestType) {
        return { ...state, isLoading: true, error: undefined, ssoAuthenticationTicket: "" };
    }

    if (action.type === toPortalSuccessType) {
        return { ...state, isLoading: false, ssoAuthenticationTicket: action.ticket, error: undefined };
    }

    if (action.type === toPortalFailureType) {
        return { ...state, isLoading: false, error: action.error };
    }

    if (action.type === cleanUpType) {
        return { ...state, isLoading: false, error: undefined, ssoAuthenticationTicket: "" };
    }
    
    return state;
};